/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemAggregationValueSchema } from './itemAggregationValueSchema';

export const numericWeightedSchema = z
  .lazy(() => itemAggregationValueSchema)
  .and(
    z.object({
      count: z.int().nullish(),
      value: z.number().nullish(),
    }),
  );
